import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 20px 50px 30px;
  gap: 20px;
  box-sizing: border-box;
  position: relative;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 400px;
  margin-bottom: 20px;
`

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
`
